import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ToastService } from '@utils/toast.service';
import { TableModule } from 'primeng/table';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { ImssService } from '@services/imss.service';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { InputOtpModule } from 'primeng/inputotp';

@Component({
  selector: 'app-asignar-correo-nss',
  imports: [
    CommonModule,
    BackboneComponent,
    BreadcrumbComponent,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    TableModule,
    InputGroupAddonModule,
    InputGroup,
    IconFieldModule,
    InputIconModule,
    InputMaskModule,
    DialogModule,
    TagModule,
    InputOtpModule,
  ],
  templateUrl: './asignar-correo-nss.component.html',
  styleUrl: './asignar-correo-nss.component.scss',
})
export class AsignarCorreoNssPage {
  private formBuilder = inject(FormBuilder);
  private imssService = inject(ImssService);
  private toastService = inject(ToastService);

  public isSaving = false;
  public statusModalDetails = false;
  public showCode = false;

  public formUpload = this.formBuilder.group({
    curp: [null, Validators.required],
    email: [null, [Validators.required, Validators.email]],
    code: [null],
  });

  public list: any[] = [];
  public itemDetails: any = [];
  public itemError: any = [];
  public searchValue: string | undefined;

  ngOnInit() {
    this.refresh();
  }

  refresh = async () => {
    await this.imssService.listAsignarCorreoNss().then((response) => (this.list = response));
  };

  get curp() {
    return this.formUpload.get('curp');
  }
  set curp(value: any) {
    this.curp.setValue(value);
  }

  get email() {
    return this.formUpload.get('email');
  }
  set email(value: any) {
    this.email.setValue(value);
  }

  get code() {
    return this.formUpload.get('code');
  }
  set code(value: any) {
    this.code.setValue(value);
  }

  sendCode = async () => {
    this.isSaving = true;

    let bodyRaw = {
      curp: this.curp.value,
      email: this.email.value,
    };

    this.imssService
      .sendCode(bodyRaw)
      .then(() => {
        this.toastService.success(`El código ha sido enviado a ${this.email.value}`);
        this.showCode = true;
      })
      .catch((err) => {
        this.toastService.error(err.error.data.message || 'Error.');
      })
      .finally(() => (this.isSaving = false));
  };

  verifyCode = async () => {
    this.isSaving = true;

    let bodyRaw = {
      curp: this.curp.value,
      email: this.email.value,
      code: this.code.value,
    };

    this.imssService
      .verifyCode(bodyRaw)
      .then(() => {
        this.toastService.success(`El correo ${this.email.value} se vinculo a ${this.curp.value}.`);
        this.showCode = false;
        this.formUpload.reset();
        this.refresh();
      })
      .catch((err) => {
        this.toastService.error(err.error.data.message || 'Error.');
      })
      .finally(() => (this.isSaving = false));
  };

  viewDetails = (item: any) => {
    this.statusModalDetails = true;
    this.itemDetails = item;
  };
}
